module.exports = __webpack_public_path__ + "static/tony-robbins-8d0f2da68517f679209eac07c5fd0b51.jpg";